import { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomTableFooter,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";

const style = {
  fontSize: 14,
  color: "#9BA69C",
  fontWeight: 550,
};

interface Props {
  data: any;
}

function ParticulariteBossTable({ data }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper} sx={{ mb: 2, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)", }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ bgcolor: theme.colors.white }}>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("note"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("charge_affaire"))}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data
          ).map((item: any, index: any) => (
            <StyledTableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: "pointer",
              }}
            >
              <StyledTableCell>{item.id}</StyledTableCell>
              <StyledTableCell>{item.phone}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
        <CustomTableFooter
          rowsPerPage={rowsPerPage}
          data={data}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </TableContainer>
  );
}

export default ParticulariteBossTable;
